import React from "react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />

      <div className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-6">

          <h1 className="text-4xl font-bold mb-8">Safety Advisory & Disclaimer</h1>

          <p className="text-gray-700 mb-6">
            SafeSheAtlas provides women-safety insights, risk indicators, and
            destination-level safety rankings based on publicly available data,
            news reports, incident patterns, and automated classification models.
            While we strive for accuracy, the information presented on this
            platform may not fully reflect real-time conditions or the complete
            safety landscape of any city, region, or country.
          </p>

          {/* Purpose */}
          <h2 className="text-2xl font-semibold mt-10 mb-4">Purpose of the Platform</h2>
          <p className="text-gray-700 mb-6">
            This platform is designed to help travelers—especially women—gain
            general awareness of safety trends, crime visibility, and recent
            incident patterns. The rankings and scores are directional indicators
            meant to support informed travel planning, not to serve as definitive
            or comprehensive safety assessments.
          </p>

          {/* Limitations */}
          <h2 className="text-2xl font-semibold mt-10 mb-4">Limitations of Safety Data</h2>
          <ul className="list-disc pl-6 text-gray-700 space-y-3 mb-6">
            <li>Not all crimes or incidents are publicly reported or captured by news sources.</li>
            <li>Automated classification models may occasionally misclassify article context or severity.</li>
            <li>Safety conditions can change rapidly due to local events, policy shifts, or other circumstances.</li>
            <li>Crime reporting standards and media coverage vary significantly between regions.</li>
          </ul>

          {/* No Legal Advice */}
          <h2 className="text-2xl font-semibold mt-10 mb-4">No Professional or Legal Advice</h2>
          <p className="text-gray-700 mb-6">
            Information provided on this website does not constitute legal advice,
            professional travel guidance, or a guarantee of personal safety. Users
            should consult official government resources, local authorities, and
            verified travel advisories before making travel-related decisions.
          </p>

          {/* User Responsibility */}
          <h2 className="text-2xl font-semibold mt-10 mb-4">User Responsibility</h2>
          <p className="text-gray-700 mb-6">
            By using SafeSheAtlas, you acknowledge that travel decisions and personal
            safety choices remain entirely your own responsibility. The platform is
            meant to complement, not replace, your own judgment, research, and due diligence.
          </p>

          {/* Liability */}
          <h2 className="text-2xl font-semibold mt-10 mb-4">Limitation of Liability</h2>
          <p className="text-gray-700 mb-6">
            SafeSheAtlas and its operators are not liable for any loss, injury,
            inconvenience, or other consequences arising from decisions or actions
            taken based on the information displayed on this website. All content
            is provided “as-is” without warranties of any kind, express or implied.
          </p>

          {/* Methodology */}
          <h2 className="text-2xl font-semibold mt-10 mb-4">Data Sources & Methodology Transparency</h2>
          <p className="text-gray-700 mb-6">
            Our rankings and safety scores are based on news data, incident classification,
            weighted scoring models, and observed trends. Methodology is periodically updated
            to improve accuracy and fairness. Users are encouraged to review updates regularly.
          </p>

          {/* SEO Transparency */}
          <h2 className="text-2xl font-semibold mt-10 mb-4">SEO Notes & Transparency Commitment</h2>
          <p className="text-gray-700 mb-6">
            As part of our mission to provide trustworthy travel safety insights,
            SafeSheAtlas maintains transparency in data sources, ranking methodology,
            and platform limitations. This page is optimized to ensure clarity for users
            searching for women safety, travel advisories, or crime trends.
          </p>

          {/* Contact */}
          <h2 className="text-2xl font-semibold mt-10 mb-4">Contact Us</h2>
          <p className="text-gray-700 mb-6">
            For questions or concerns, please reach us at:
            <br />
            <span className="text-teal-600 font-semibold">
              stay-safe@safesheatlas.com
            </span>
          </p>

          <p className="text-gray-600 text-sm mt-8">
            Last Updated: {new Date().toLocaleDateString()}
          </p>

        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Disclaimer;
